export default "__VITE_ASSET__4EPvD5pz__"